import { render, staticRenderFns } from "./WaitListDetail.vue?vue&type=template&id=71347c76&scoped=true&"
import script from "./WaitListDetail.vue?vue&type=script&lang=js&"
export * from "./WaitListDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaitListDetail.vue?vue&type=style&index=0&id=71347c76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71347c76",
  null
  
)

export default component.exports